var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "center-team" } },
    [
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          {
            staticClass:
              "sticky z-40 flex items-center justify-between gap-4 px-6 py-3 left-60",
            style: { width: "calc(100vw - 15rem - 0.5rem)" }
          },
          [
            _c(
              "div",
              { staticClass: "flex items-center gap-4" },
              [
                _c("BlTextTitle3", { attrs: { text: "Team" } }),
                _vm._v(" "),
                _c("BlBubbleCount", { attrs: { count: _vm.totalUsers || 0 } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center gap-4" },
              [
                _c("div", { staticClass: "relative" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center h-10 gap-2 px-4 transition-all duration-300 border rounded cursor-pointer bg-pure-white hover:bg-grey-200 border-light-purple",
                      on: {
                        click: function($event) {
                          _vm.menuOpened = !_vm.menuOpened
                        }
                      }
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "text-light-purple",
                        attrs: { text: "Invite bulk" }
                      }),
                      _vm._v(" "),
                      _c("BlIcon", {
                        staticClass: "w-6 h-6",
                        style: {
                          transform: _vm.menuOpened ? "rotate(180deg)" : ""
                        },
                        attrs: { icon: "chevron-down" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.menuOpened
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "absolute right-0 z-50 flex flex-col gap-1 px-2 py-2 mt-3 border rounded top-full bg-pure-white border-slate-400"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "px-4 py-2 rounded cursor-pointer min-w-40 hover:bg-hover-state",
                              on: {
                                click: function($event) {
                                  _vm.manualEntryOpened = true
                                }
                              }
                            },
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-slate-1000",
                                attrs: { text: "Manual entry" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "px-4 py-2 rounded cursor-pointer min-w-40 hover:bg-hover-state",
                              on: {
                                click: function($event) {
                                  _vm.viaCSVOpened = true
                                }
                              }
                            },
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-slate-1000",
                                attrs: { text: "Via CSV" }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("BlInputButton", {
                  attrs: { icon: "plus", label: "Member" },
                  on: {
                    clicked: function($event) {
                      _vm.newMemberOpened = true
                    }
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.newMemberOpened
        ? _c("NewUserModal", {
            attrs: { centerId: _vm.center.id },
            on: {
              "close-modal": function($event) {
                _vm.newMemberOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.manualEntryOpened
        ? _c("InviteManualBulkUserModal", {
            attrs: { centerId: _vm.center.id },
            on: {
              "after-commit": _vm.fetchUsers,
              "close-modal": function($event) {
                _vm.manualEntryOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.viaCSVOpened
        ? _c("InviteCSVBulkUserModal", {
            attrs: { centerId: _vm.center.id },
            on: {
              "after-commit": _vm.fetchUsers,
              "close-modal": function($event) {
                _vm.viaCSVOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          {
            staticClass:
              "sticky z-30 flex items-center gap-2 px-6 py-3 left-60",
            style: { width: "calc(100vw - 15rem - 0.5rem)" }
          },
          [
            _c("BlInputSearch", {
              staticClass: "w-80",
              attrs: { input: _vm.searchInput },
              on: { changed: _vm.onInputSearch }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-40" },
              [
                _c("BlInputFilter", {
                  attrs: { input: _vm.filterInput },
                  on: { changed: _vm.onChangeFilter }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("BlSort", {
              staticClass: "w-60",
              attrs: {
                options: _vm.sortOptions,
                defaultValue: _vm.defaultSort
              },
              on: {
                change: function($event) {
                  return _vm.onChangeSort($event)
                }
              },
              model: {
                value: _vm.sortInput,
                callback: function($$v) {
                  _vm.sortInput = $$v
                },
                expression: "sortInput"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.exceedTeamSizeLimits > 0
        ? _c("div", { staticClass: "flex" }, [
            _c(
              "div",
              {
                staticClass:
                  "sticky z-10 flex items-center gap-2 px-6 pb-3 left-60",
                style: { width: "calc(100vw - 15rem - 0.5rem)" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center w-full gap-4 px-4 py-2 rounded bg-tulip-200"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex items-center justify-center flex-shrink-0 w-10 h-10 rounded bg-tulip-300"
                      },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "warning", color: "tulip-7" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("BlTextBody2", {
                          staticClass: "text-tulip-800",
                          attrs: { text: "The current subscription is set to" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "text-tulip-800",
                          attrs: { text: _vm.center.team_size_limit || 0 }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "text-tulip-800",
                          attrs: { text: "seats, but there are" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "text-tulip-800",
                          attrs: { text: _vm.center.total_active_members }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "text-tulip-800",
                          attrs: {
                            text: "active members, exceeding the limit by"
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "text-tulip-800",
                          attrs: {
                            text:
                              _vm.center.total_active_members -
                              (_vm.center.team_size_limit || 0) +
                              "."
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "text-tulip-800",
                          attrs: { text: "Please review the seat allocation." }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.pageLoading
        ? _c("div", { staticClass: "grid h-128 place-items-center" }, [
            _c("div", { staticClass: "blum-loader" })
          ])
        : !_vm.users.length
        ? _c(
            "div",
            { staticClass: "flex flex-col items-center justify-center h-128" },
            [
              _c("BlTextBody1", {
                staticClass: "text-center",
                attrs: { text: "Team member(s) not found." }
              })
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "mb-8" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "sticky z-20 flex items-center flex-grow rounded-t top-10 bg-slate-300",
                  attrs: { id: "center-team-header" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "sticky z-10 flex pl-6 left-60 bg-slate-100"
                    },
                    [
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 w-20 h-12 px-4 border-t border-l rounded-tl bg-slate-300 border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "ID" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 h-12 px-4 border-t border-r w-60 bg-slate-300 border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Name" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "BlTooltip",
                    {
                      staticClass:
                        "flex items-center flex-shrink-0 h-12 px-4 border-t w-50 bg-slate-300 border-slate-400"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        attrs: { text: "Email" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "BlTooltip",
                    {
                      staticClass:
                        "flex items-center flex-shrink-0 h-12 px-4 border-t w-50 bg-slate-300 border-slate-400"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        attrs: { text: "Role" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "BlTooltip",
                    {
                      staticClass:
                        "flex items-center flex-shrink-0 h-12 px-4 border-t w-50 bg-slate-300 border-slate-400"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        attrs: { text: "Status" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "BlTooltip",
                    {
                      staticClass:
                        "flex items-center flex-shrink-0 h-12 px-4 border-t w-50 bg-slate-300 border-slate-400"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        attrs: { text: "Account creation date" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "BlTooltip",
                    {
                      staticClass:
                        "flex items-center flex-shrink-0 h-12 pl-4 border-t w-50 bg-slate-300 border-slate-400"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        attrs: { text: "Account deactivation date" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "BlTooltip",
                    {
                      staticClass:
                        "flex items-center flex-shrink-0 h-12 px-4 border-t w-50 bg-slate-300 border-slate-400"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        attrs: { text: "Access permission" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "BlTooltip",
                    {
                      staticClass:
                        "flex items-center flex-shrink-0 h-12 px-4 border-t w-50 bg-slate-300 border-slate-400"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        attrs: { text: "Access tags" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sticky right-0 z-10 flex flex-grow pr-6 bg-slate-100"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center flex-grow flex-shrink-0 w-12 h-12 px-4 border-t border-r rounded-tr bg-slate-300 border-slate-400"
                        },
                        [_c("BlTextSubtitle3", { attrs: { text: "" } })],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.users, function(user, idx) {
                return _c("CenterTeamItem", {
                  key: user.id,
                  attrs: {
                    user: user,
                    centerId: _vm.center.id,
                    isLast: idx + 1 === _vm.users.length
                  }
                })
              })
            ],
            2
          ),
      _vm._v(" "),
      _vm.totalUsers > 25
        ? _c(
            "div",
            { staticClass: "flex mb-36" },
            [
              _c("BlInputPagination", {
                staticClass: "sticky left-66",
                style: { width: "calc(100vw - 15rem - 3rem - 0.5rem)" },
                attrs: {
                  page: _vm.page,
                  perPage: _vm.perPage,
                  total: _vm.totalUsers
                },
                on: {
                  changed: _vm.changePage,
                  "changed-per-page": _vm.changePerPage
                }
              })
            ],
            1
          )
        : _c("div", { staticClass: "mb-46" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6dc4d7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6dc4d7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/superAdmin/center/CenterTeam.vue
// module id = null
// module chunks = 